// App-level distance counter for on-water sessions (Start → Stop). Lives in
// WorkoutProvider so it keeps counting on every screen and through pauses.
import { useEffect, useRef } from 'react';
import { createOdometer } from '@/lib/odometer';

export default function useSessionOdometer({ active, pm5Device, setDistance }) {
  const odoRef = useRef(createOdometer());

  useEffect(() => {
    const demo = (() => { try { return localStorage.getItem('demo_mode') === 'true'; } catch { return false; } })();
    if (!active || pm5Device || demo) return undefined;
    const odo = odoRef.current;
    odo.reset();
    const add = (fix) => {
      const d = odo.push(fix);
      if (d > 0) setDistance((prev) => (prev || 0) + d);
    };
    let watchId = null;
    if (typeof navigator !== 'undefined' && navigator.geolocation) {
      watchId = navigator.geolocation.watchPosition(
        (pos) => add({ lat: pos.coords.latitude, lng: pos.coords.longitude, speed: pos.coords.speed, source: 'phone' }),
        (err) => console.warn('[odometer] GPS error:', err?.message),
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 1000 },
      );
    }
    const onCase = (e) => {
      const d = e.detail || {};
      add({ lat: d.lat, lng: d.lng, speed: typeof d.speed === 'number' ? d.speed : undefined, source: 'case' });
    };
    window.addEventListener('crewz-gps-update', onCase);
    return () => {
      if (watchId !== null) navigator.geolocation.clearWatch(watchId);
      window.removeEventListener('crewz-gps-update', onCase);
    };
  }, [active, pm5Device, setDistance]);
}
